import { render, staticRenderFns } from "./setAssignee.vue?vue&type=template&id=c58c95e8"
import script from "./setAssignee.vue?vue&type=script&lang=js"
export * from "./setAssignee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports